export function WSImageLoaded() {
  var parentWS = this["parentWS"];
  parentWS.RenderWS();
}
